export default {
  labels: {
    card: 'Card de credit',
    bank_account: 'Cont bancar',
  },
  alerts: {
    payments_not_configured:
      'Plățile nu sunt configurate încă. Vă rugăm să contactați furnizorul pentru a activa plățile, apoi reveniți la acest pas.',
  },
  buttons: {
    change_payment_method: 'Schimbați metoda de plată',
    save_payment_info: 'Salvați informațiile de plată',
  },
  toasts: {
    failed_to_init_payment_setup:
      'Procesul de configurare a plății nu a putut fi inițializat, vă rugăm să reîncărcați pagina',
    successfully_saved_payment_method: 'Informațiile de plată au fost salvate',
  },
};
